import './weeks-view.css';

const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

const LEFT_MONTHS = new Set([8, 9, 10]); // September, October, November

const MONTH_COLORS = [
  { background: '#c9ddf8', border: '#a3c1ed' },
  { background: '#f5ccc8', border: '#e8a9a3' },
  { background: '#f5e6a3', border: '#e6d27e' },
  { background: '#bee5ca', border: '#8fd4a2' },
  { background: '#e0ccf7', border: '#c9a8ed' },
];

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function ordinalSuffix(day) {
  if (day >= 11 && day <= 13) return 'th';
  const last = day % 10;
  if (last === 1) return 'st';
  if (last === 2) return 'nd';
  if (last === 3) return 'rd';
  return 'th';
}

function formatDateLabel(startDate) {
  const start = new Date(startDate + 'T00:00:00');
  const daysUntilSunday = (7 - start.getDay()) % 7;
  const sunday = new Date(start);
  sunday.setDate(sunday.getDate() + daysUntilSunday);

  const dayName = DAY_NAMES[sunday.getDay()];
  const monthName = MONTH_NAMES[sunday.getMonth()];
  const day = sunday.getDate();
  const year = sunday.getFullYear();
  return `${dayName}, ${monthName} ${day}${ordinalSuffix(day)}, ${year}`;
}

function getWeekPrefix(week) {
  return week.seasonType === 3 ? week.name : `Week ${week.week}`;
}

function renderWeekLabel(week) {
  const prefix = getWeekPrefix(week);
  const dateStr = formatDateLabel(week.startDate);
  return (
    <>
      <span className="week-prefix">{prefix}</span>
      <span className="week-date">{dateStr}</span>
    </>
  );
}

function groupByMonth(weeks) {
  const grouped = [];
  let currentMonth = null;
  let currentGroup = null;

  for (const week of weeks) {
    const month = new Date(week.startDate + 'T00:00:00').getMonth();
    if (month !== currentMonth) {
      currentMonth = month;
      currentGroup = { monthIndex: month, month: MONTH_NAMES[month], weeks: [] };
      grouped.push(currentGroup);
    }
    currentGroup.weeks.push(week);
  }

  return grouped;
}

function renderBubble(group, colorIndex, onSelectWeek) {
  const color = MONTH_COLORS[colorIndex % MONTH_COLORS.length];
  return (
    <div
      key={group.month}
      className="month-bubble"
      style={{ background: color.background, borderColor: color.border }}
    >
      <span className="month-label">{group.month}</span>
      <div className="month-bubble-weeks">
        {group.weeks.map((week) => (
          <span key={week.week} className="week-link" onClick={() => onSelectWeek(week)}>
            {renderWeekLabel(week)}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function WeeksView({ season, weeks, loading, error, onSelectWeek, onBack }) {
  const grouped = groupByMonth(weeks.regularSeason);
  const leftGroups = grouped.filter(g => LEFT_MONTHS.has(g.monthIndex));
  const rightGroups = grouped.filter(g => !LEFT_MONTHS.has(g.monthIndex));

  let colorIndex = 0;
  const leftColors = leftGroups.map(() => colorIndex++);
  const rightColors = rightGroups.map(() => colorIndex++);

  return (
    <div className="app">
      <button className="back-button" onClick={onBack}>Back to Seasons</button>
      <h2 className="section-title">{season.name}</h2>

      {loading && <p className="loading">Loading weeks...</p>}
      {error && <p className="error">Error: {error}</p>}

      {!loading && !error && (
        <div className="weeks-columns">
          <div className="weeks-column">
            {leftGroups.map((group, i) => renderBubble(group, leftColors[i], onSelectWeek))}
          </div>
          <div className="weeks-column">
            {rightGroups.map((group, i) => renderBubble(group, rightColors[i], onSelectWeek))}
            {weeks.postseason.length > 0 && (
              <div className="month-bubble" style={{ background: '#f0f0f0', borderColor: '#ccc' }}>
                <span className="month-label">Postseason</span>
                <div className="month-bubble-weeks">
                  {weeks.postseason.map((week) => (
                    <span key={week.week} className="week-link" onClick={() => onSelectWeek(week)}>
                      {renderWeekLabel(week)}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
